import { render, staticRenderFns } from "./PriceText.vue?vue&type=template&id=6406ce7b&scoped=true"
import script from "./PriceText.vue?vue&type=script&lang=js"
export * from "./PriceText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6406ce7b",
  null
  
)

export default component.exports